module.exports = __webpack_public_path__ + "img/dwellys-logo.0d396018.png";